import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {
  AutocompleteArrayInput,
  Create,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
} from 'react-admin';
import CategoryIcon from '@mui/icons-material/Category';
import { useEffect, useState } from 'react';
import { getAllSubMerchant } from '../../services/SubMerchant';
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';

const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid Color.Main',
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};


const CategoryCreateToolbar = (props) => {
  const navigate = useNavigate();
  const handleBack = (e) => {
    e.preventDefault();
    navigate('/Category');
  };
  return (
    <Toolbar sx={{ justifyContent: 'space-between' }} {...props}>
      <Button
        startIcon={<KeyboardBackspaceIcon />}
        onClick={handleBack}
        sx={backButton}
      >
        Back
      </Button>
      <SaveButton sx={saveButton} />
    </Toolbar>
  );
};

export const CategoryCreate = (props) => {
  const [submerchants, setSubmerchants] = useState([]);
  useEffect(() => {
    getAllSubMerchant()
      .then((result) => {
        setSubmerchants(result.allSubMerchants);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <Create {...props}>
      <SimpleForm toolbar={<CategoryCreateToolbar />}>
        <Grid sx={{ textAlign: 'left' }}>
          <Button
            endIcon={<CategoryIcon sx={{ color: Color.Main }} />}
            sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
            size="medium"
          >
            <Typography variant="h3">Create Category</Typography>
          </Button>
        </Grid>
        <Divider sx={{ width: '100%', mb: 2 }} />
        <Grid
          sx={{
            display: 'flex',
            p: 3,
            width: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid
            container={true}
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              width: { xs: '100%', md: '80%' },
            }}
          >
            <Grid item xs={0} md={4} lg={2} sx={{ textAlign: 'center' }}></Grid>
            <Grid item xs={12} sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box>
                    <TextInput
                      required
                      source="name"
                      label="Name"
                      fullWidth
                      variant="outlined"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box>
                    <TextInput
                      required
                      source="description"
                      label="Description"
                      fullWidth
                      variant="outlined"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box>
                    <AutocompleteArrayInput
                      id="subMerchantIDs"
                      optionText="name"
                      optionValue="id"
                      source="submerchantIDs"
                      label="SubMerchant"
                      choices={submerchants}
                      variant="outlined"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
